import { FC } from "react"
import s from "@pages/fid_view/styles.module.css"
import { Typography } from "@mui/material"
import { cardTitle } from "@components/CardEvent/CardEvent/CardEventStyles"
export interface DescriptionContentProps {
  description?: string
}

const capitalize = (str: string) => str[0].toUpperCase() + str.slice(1)
const DescriptionContent: FC<DescriptionContentProps> = ({ description }) => {
  if (!description) return null
  return (
    <div className={s.description_box}>
      <Typography gutterBottom variant="h6" component="div" sx={cardTitle}>
        Описание:
      </Typography>
      <Typography variant="body2" color={`var(--secondary-text)`}>
        {capitalize(description)}
      </Typography>
    </div>
  )
}
export default DescriptionContent
